import type { IconProps } from "./Icons";

export const IconPersonalData = ({
  width = 32,
  height = 32,
  color = "#0B3E5F",
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16"
      cy="10.8"
      r="6.2"
      stroke={color}
      strokeWidth="2"
    />
    <path
      d="M6.8 27.2C8.3 21.9 12.1 18.8 16 18.8C19.9 18.8 23.7 21.9 25.2 27.2"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
